export default class GenericStack<ItemType> {
  private items: ItemType[] = [];

  push = (item: ItemType): number => this.items.push(item);

  pop = (): ItemType | undefined => this.items.pop();

  get length(): number {
    return this.items.length;
  }

  get copyOfAllItems(): ItemType[] {
    return this.items.slice();
  }
}
